jQuery(function($){
  $('.js-works').on('click', function(){
    var product_id = $('#product-filter').val();
    var color_id = $('#color-filter').val();
    var page = $(this).data('page');
    var last_index = $(this).data('last-index');
    $(this).data('page', page + 1);
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        'action': 'get_works',
        'product': product_id,
        'color': color_id,
        'page': page,
        'last_index': last_index
      }
    }).done(function(response){
      var res = JSON.parse(response);
      $('.works-listing-grid > div > .sv-g').append(res.content);
      if (res.lastpage){
        $('.js-works').css('display', 'none');
      }
      initWorksPopin($);
      var lastId = $('.works-listing-grid > div > .sv-g > div:last-child .work-teaser__popin-open').data('id');
      $('.js-works').data('last-index', lastId + 1);
    });
  });
});
